<template>
  <div>
    <div class="w3-col" :class="events.upcoming.length > 0 ? 'l8' : 'l12'">
      <sortFilter type="news"></sortFilter>
      
      <div class="sectionHeader" ref="upcoming">
        <h5 style="margin:0;">Local News</h5>
      </div>
      <news layout="wide"></news>
    </div>

    <!-- sidebar -->
    <div v-if="events.upcoming.length > 0">
      <div class="w3-col l4 sidebar">
        <template v-if="width > 600">
          <div class="sectionHeader">
            <h5>Upcoming Events</h5>
            <div class="w3-right">
              <div class="viewAll">
                <button class="w3-button" @click="viewAll('events')">View More Events</button>
              </div>
            </div>
          </div>
          <events type="upcoming" :image="true" layout="thin"></events>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import gmapsInit from '../gmaps'
import events from '@/components/events.vue'
import news from '@/components/news.vue'
import sortFilter from '@/components/sortFilter.vue'

export default {
  name: "Events",
  components: {
    events,
    news,
    sortFilter
  },
  computed: mapState([
    'news',
    'events',
    'searchFilter'
  ]),
  data() {
    return {
      dataLoaded: false,
      width: window.innerWidth
    }
  },
  created() {
    this.$store.dispatch('getNews').then((newsData) => {
      this.dataLoaded = true
    })
    this.$store.dispatch('getActiveAds')
    this.$store.commit('setInitSearch', '')
  },
  mounted() {
    if (this.$route.params.scrollPosition) {
      if (this.$refs[this.$route.params.scrollPosition]) {
        this.$refs[this.$route.params.scrollPosition].scrollIntoView()
        window.scrollBy(0, -64)
      }
    }
  },
  methods: {
    viewNews(news) {
      this.$router.push({ name: 'news-details', params: {news: news} })
    },
    link(type, uid) {
      let sharePage = ""
      if (type === 'fb') {
        sharePage = encodeURI("https://www.facebook.com/sharer.php?u=https://daytonalocal.com/news/" + uid);
      } else if (type === 'tw') {
        sharePage = encodeURI("https://twitter.com/intent/tweet?url=https://daytonalocal.com/news/" + uid);
      } else if (type === 'gp') {
        sharePage = encodeURI("https://plus.google.com/share?url=https://daytonalocal.com/news/" + uid);
      } else {
        // nothing
      }
      return sharePage;
    }
  }
}
</script>

<style scoped>
</style>
